export default __webpack_public_path__ + "64e5596bd96eea9ee7042ce9f96072b1.svg";